export default __webpack_public_path__ + "static/media/elf.d11baa22.svg";